import React, { useRef } from 'react';
import { Slider } from '@/widgets/Slider';
import { featureTimeslotsConfig } from '@/shared/config/tests/e2e/features/booking';
import { useElementScroll } from '@/shared/hooks/dom/scroll/useElementScroll';
import { classNames } from '@/shared/lib/classnames/classnames';
import { DayItem } from './DayItem';
import type { ISchedule } from '@/entities/booking/model/types';
import type { DaysListProps } from '../../model/types';
export const DaysList: React.FC<DaysListProps> = ({
  schedule,
  selectedDay,
  hasButtonsOffset = true,
  onDayClick
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const {
    scrollToElement
  } = useElementScroll(containerRef);
  const dayClick = (day: ISchedule, index: number) => {
    onDayClick(day);
    scrollToElement(index);
  };
  return <Slider itemTag={'button'} containerClassName={classNames('', {
    'w-[calc(100%-2rem)] mx-auto': !hasButtonsOffset
  })} testId={featureTimeslotsConfig.ids.daysContainer} data-sentry-element="Slider" data-sentry-component="DaysList" data-sentry-source-file="DaysList.tsx">
      {schedule.map((item, index) => {
      return <DayItem key={item.date} day={item} isSelected={selectedDay.date === item.date} onClick={day => dayClick(day, index)} />;
    })}
    </Slider>;
};